module.exports = __webpack_public_path__ + "static/media/yt.871a66af.svg";